import PropTypes from "prop-types";
import React, { useEffect, useState, useCallback } from "react";
import logolight from "../../assets/images/logo.png";
import logodark from "../../assets/images/logo.png";
import "./Login.css";

import {
  Row,
  Col,
  CardBody,
  Card,
  Alert,
  Container,
  Form,
  Input,
  FormFeedback,
  Label,
} from "reactstrap";

import {
  LoginSocialGoogle,
  LoginSocialFacebook,
  LoginSocialInstagram,
} from 'reactjs-social-login';

import {
  FacebookLoginButton,
  GoogleLoginButton,
  InstagramLoginButton,
} from 'react-social-login-buttons';

//redux
import { useSelector, useDispatch } from "react-redux";

import { Link, redirect } from "react-router-dom";
import withRouter from "../../components/Common/withRouter";
// import FacebookLogin from 'react-facebook-login';
import { Helmet } from "react-helmet";



// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

//Social Media Imports
import { GoogleLogin } from "react-google-login";
// import TwitterLogin from "react-twitter-auth"
// import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";

// actions
import { loginUser, socialLogin } from "../../store/actions";

//Import config
import { facebook, google } from "../../config";

import { useNavigate } from "react-router-dom";

import { LoginService } from "../../services/auth";
import { PostData } from "../../services/api";
import Swal from "sweetalert2";

// Función para traducir mensajes de error comunes al español
const translateError = (errorMessage) => {
  if (!errorMessage) return "Ha ocurrido un error";
  
  const errorLower = errorMessage.toLowerCase();
  
  // Traducciones comunes
  const translations = {
    "email exist": "Este correo electrónico ya está registrado",
    "user not found": "Usuario no encontrado",
    "email unverified": "Email no verificado. Por favor verifica tu correo electrónico",
    "email no verificado": "Email no verificado. Se ha enviado un nuevo código de verificación a tu correo electrónico.",
    "cuenta inactiva": "Cuenta inactiva. Por favor verifica tu correo electrónico para activar tu cuenta",
    "invalid credentials": "Credenciales inválidas",
    "unauthorized": "No autorizado",
    "forbidden": "Acceso denegado",
    "not found": "No encontrado",
    "bad request": "Solicitud inválida",
    "internal server error": "Error interno del servidor",
    "network error": "Error de conexión. Verifica tu internet",
    "timeout": "Tiempo de espera agotado. Intenta nuevamente",
    "verification code incorrect": "Código de verificación incorrecto",
    "código de verificación incorrecto": "Código de verificación incorrecto",
    "verification code expired": "El código de verificación ha expirado",
    "el código de verificación ha expirado": "El código de verificación ha expirado",
    "no hay código de verificación pendiente": "No hay código de verificación pendiente",
  };
  
  // Buscar traducción
  for (const [key, translation] of Object.entries(translations)) {
    if (errorLower.includes(key)) {
      return translation;
    }
  }
  
  // Si no hay traducción, retornar el mensaje original
  return errorMessage;
};

const Login = (props) => {
  document.title = "CRM IHG";
  const navigate = useNavigate();

  const [errorAlert, setEA] = useState();
  const [passInput, setPassInput] = useState("password");
  const [showVerification, setShowVerification] = useState(false);
  const [verificationEmail, setVerificationEmail] = useState("");
  const [verificationCode, setVerificationCode] = useState(["", "", "", "", "", ""]);
  const [loading, setLoading] = useState(false);
  const [resendCooldown, setResendCooldown] = useState(0);
  const [savedCredentials, setSavedCredentials] = useState(null); // Guardar credenciales para login automático
  const [showCompanySelector, setShowCompanySelector] = useState(false);
  const [availableCompanies, setAvailableCompanies] = useState([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState("");

  const [provider, setProvider] = useState('');
  const [profile, setProfile] = useState();

  const onLoginStart = useCallback(() => {
    alert('login start');
  }, []);

  const onLogoutSuccess = useCallback(() => {
    setProfile(null);
    setProvider('');
    alert('logout success');
  }, []);

  const onLogout = useCallback(() => { }, []);

  // Manejar código de verificación
  const handleCodeChange = (index, value) => {
    if (value.length > 1) return; // Solo un dígito por input
    
    const newCode = [...verificationCode];
    newCode[index] = value.replace(/\D/g, ""); // Solo números
    setVerificationCode(newCode);

    // Auto-focus siguiente input
    if (value && index < 5) {
      const nextInput = document.getElementById(`login-code-${index + 1}`);
      if (nextInput) nextInput.focus();
    }
  };

  const handleCodeKeyDown = (index, e) => {
    if (e.key === "Backspace" && !verificationCode[index] && index > 0) {
      const prevInput = document.getElementById(`login-code-${index - 1}`);
      if (prevInput) prevInput.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, 6);
    if (pastedData.length === 6) {
      const newCode = pastedData.split("");
      setVerificationCode(newCode);
      // Focus último input
      setTimeout(() => {
        const lastInput = document.getElementById(`login-code-5`);
        if (lastInput) lastInput.focus();
      }, 0);
    }
  };

  const handleVerifyCode = async () => {
    const code = verificationCode.join("");
    if (code.length !== 6) {
      Swal.fire({
        icon: "warning",
        title: "Código incompleto",
        text: "Por favor ingresa el código completo de 6 dígitos",
        confirmButtonColor: "#E9553E",
      });
      return;
    }

    setLoading(true);
    try {
      const response = await PostData("/users/verify-email", {
        email: verificationEmail,
        code: code,
      });

      if (response?.data?.success) {
        // Si hay credenciales guardadas, hacer login automáticamente
        if (savedCredentials) {
          try {
            const loginResult = await LoginService(savedCredentials);
            if (loginResult) {
              // Login exitoso, redirigir al dashboard
              navigate("/dashboard");
              return;
            }
          } catch (loginError) {
            console.error("Error al hacer login automático después de verificar:", loginError);
            // Si falla el login automático, mostrar mensaje y volver al login
            Swal.fire({
              icon: "success",
              title: "¡Email verificado!",
              text: "Tu cuenta ha sido activada exitosamente. Por favor inicia sesión.",
              confirmButtonColor: "#E9553E",
            }).then(() => {
              setShowVerification(false);
              setVerificationCode(["", "", "", "", "", ""]);
              setVerificationEmail("");
              setSavedCredentials(null);
            });
            return;
          }
        } else {
          // No hay credenciales guardadas, mostrar mensaje y volver al login
          Swal.fire({
            icon: "success",
            title: "¡Email verificado!",
            text: "Tu cuenta ha sido activada exitosamente. Por favor inicia sesión.",
            confirmButtonColor: "#E9553E",
          }).then(() => {
            setShowVerification(false);
            setVerificationCode(["", "", "", "", "", ""]);
            setVerificationEmail("");
          });
        }
      }
    } catch (error) {
      const rawErrorMessage = error.response?.data?.error?.message || error.message || "Código de verificación incorrecto";
      const errorMessage = translateError(rawErrorMessage);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: errorMessage,
        confirmButtonColor: "#E9553E",
      });
      // Limpiar código
      setVerificationCode(["", "", "", "", "", ""]);
      document.getElementById("login-code-0")?.focus();
    } finally {
      setLoading(false);
    }
  };

  const handleCompanySelection = async () => {
    if (!selectedCompanyId) {
      Swal.fire({
        icon: "warning",
        title: "Selecciona una compañía",
        text: "Por favor selecciona la compañía con la que deseas ingresar",
        confirmButtonColor: "#E9553E",
      });
      return;
    }

    setLoading(true);
    try {
      const result = await LoginService({
        ...savedCredentials,
        companyId: selectedCompanyId
      }, true); // true indica que es login completo con companyId

      if (result) {
        navigate("/dashboard");
      }
    } catch (err) {
      const errorMessage = 
        err.response?.data?.error?.message || 
        err.response?.data?.message || 
        err.message || 
        "Error al completar el login";
      
      Swal.fire({
        icon: "error",
        title: "Error",
        text: translateError(errorMessage),
        confirmButtonColor: "#E9553E",
      });
      setLoading(false);
    }
  };

  const handleResendCode = async () => {
    if (resendCooldown > 0) return;

    setLoading(true);
    try {
      const response = await PostData("/users/send-verification-code", {
        email: verificationEmail,
      });

      if (response?.data?.success) {
        setResendCooldown(60);
        Swal.fire({
          icon: "success",
          title: "Código reenviado",
          text: "Se ha enviado un nuevo código a tu correo electrónico",
          confirmButtonColor: "#E9553E",
        });
      }
    } catch (error) {
      const rawErrorMessage = error.response?.data?.error?.message || error.message || "Error al reenviar código";
      const errorMessage = translateError(rawErrorMessage);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: errorMessage,
        confirmButtonColor: "#E9553E",
      });
    } finally {
      setLoading(false);
    }
  };

  // Cooldown timer
  useEffect(() => {
    if (resendCooldown > 0) {
      const timer = setTimeout(() => {
        setResendCooldown(resendCooldown - 1);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [resendCooldown]);

  // Auto-verificar cuando se complete el código
  useEffect(() => {
    if (showVerification && verificationCode.every(digit => digit !== "") && !loading) {
      const code = verificationCode.join("");
      if (code.length === 6) {
        // Pequeño delay para mejor UX
        const timer = setTimeout(() => {
          handleVerifyCode();
        }, 300);
        return () => clearTimeout(timer);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [verificationCode, showVerification]);

  const dispatch = useDispatch();

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Ingresa tu correo electrónico"),
      password: Yup.string().required("Ingresa tu contraseña"),
    }),
    onSubmit: async (values) => {
      setLoading(true);
      setEA(false);
      try {
        const result = await LoginService(values);
        
        // Si hay múltiples compañías, mostrar selector
        if (result && result.hasMultipleCompanies && result.companies) {
          setAvailableCompanies(result.companies);
          setShowCompanySelector(true);
          setSavedCredentials(values); // Guardar credenciales para usar después
          setLoading(false);
          return;
        }
        
        // Login normal (una sola compañía)
        if (result) {
          navigate("/dashboard");
        } else {
          setEA(true);
        }
      } catch (err) {
        console.log("=== ERROR EN LOGIN ===");
        console.log("Error completo:", err);
        console.log("Error response:", err.response);
        console.log("Error response data:", err.response?.data);
        console.log("Error response data.error:", err.response?.data?.error);
        
        // Obtener el mensaje de error de la estructura del backend
        // El backend devuelve: { error: { statusCode: 400, name: "BadRequestError", message: "..." } }
        const errorMessage = 
          err.response?.data?.error?.message || 
          err.response?.data?.message || 
          err.message || 
          "";
        
        console.log("Mensaje de error extraído:", errorMessage);
        
        const errorLower = errorMessage.toLowerCase();
        console.log("Mensaje en minúsculas:", errorLower);
        
        // Verificar si el error es de email no verificado
        // El mensaje del backend es: "Email no verificado. Se ha enviado un nuevo código de verificación a tu correo electrónico."
        const isEmailUnverified = 
          errorLower.includes("email no verificado") || 
          errorLower.includes("email unverified") ||
          errorLower.includes("se ha enviado un nuevo código") ||
          errorLower.includes("nuevo código de verificación");
        
        console.log("¿Es email no verificado?", isEmailUnverified);
        console.log("Verificaciones individuales:");
        console.log("- 'email no verificado':", errorLower.includes("email no verificado"));
        console.log("- 'email unverified':", errorLower.includes("email unverified"));
        console.log("- 'se ha enviado un nuevo código':", errorLower.includes("se ha enviado un nuevo código"));
        console.log("- 'nuevo código de verificación':", errorLower.includes("nuevo código de verificación"));
        
        if (isEmailUnverified) {
          console.log("✅ Mostrando pantalla de verificación");
          // Guardar credenciales para login automático después de verificar
          setSavedCredentials({
            email: values.email,
            password: values.password,
          });
          // Mostrar pantalla de verificación sin modal
          // Asegurar que no se muestre el error de credenciales
          setEA(false);
          setVerificationEmail(values.email);
          setShowVerification(true);
          setResendCooldown(60); // 60 segundos de cooldown
        } else {
          console.log("❌ Mostrando error de credenciales incorrectas");
          console.log("Mensaje completo que no coincidió:", errorMessage);
          setEA(true);
        }
      } finally {
        setLoading(false);
      }

      // if(!error)

      // dispatch(loginUser(res, props.router.navigate));
    },
  });

  // const { error } = useSelector((state) => ({
  //   error: state.login.error,
  // }));

  // handleValidSubmit
  // const handleValidSubmit = (event, values) => {
  //   dispatch(loginUser(values, props.router.navigate));
  // };

  const signIn = (res, type) => {
    if (type === "google" && res) {
      const postData = {
        name: res.profileObj.name,
        email: res.profileObj.email,
        token: res.tokenObj.access_token,
        idToken: res.tokenId,
      };
      dispatch(socialLogin(postData, props.router.navigate, type));
    } else if (type === "facebook" && res) {
      const postData = {
        name: res.name,
        email: res.email,
        token: res.accessToken,
        idToken: res.tokenId,
      };
      dispatch(socialLogin(postData, props.router.navigate, type));
    }
  };

  //handleGoogleLoginResponse
  const googleResponse = (response) => {
    signIn(response, "google");
  };

  //handleTwitterLoginResponse
  // const twitterResponse = e => {}

  //handleFacebookLoginResponse
  const handleFacebookCallback = (response) => {
    console.log(response)
  };


  useEffect(() => {
    //document.body.className = "bg-pattern";
    // remove classname when component will unmount
    return function cleanup() {
      document.body.className = "";
    };
  });

  return (
    <React.Fragment>
      <Helmet>
        <title>Iniciar Sesión - CRM IHG</title>
      </Helmet>
      <div className="login-container">
        <div className="login-image-section"></div>
        <div className="login-form-section">
          <div className="login-wrapper">
            <div className="login-header">
              <img
                src={logodark}
                alt="InnovaHubGroup"
                className="login-logo"
              />
              <h1 className="login-title">
                {showVerification ? "Verifica tu email" : "Bienvenido"}
              </h1>
              <p className="login-subtitle">
                {showVerification
                  ? `Ingresa el código enviado a ${verificationEmail}`
                  : "Inicia sesión para continuar"}
              </p>
            </div>

            <div className="login-body">
              {showCompanySelector ? (
                <div className="company-selector-container">
                  <h2 className="company-selector-title">Selecciona la compañía</h2>
                  <p className="company-selector-subtitle">
                    Tu correo está asociado a múltiples compañías. Selecciona con cuál deseas ingresar.
                  </p>
                  
                  <div className="company-list">
                    {availableCompanies.map((company) => (
                      <div
                        key={company.id}
                        className={`company-item ${selectedCompanyId === company.id ? 'selected' : ''}`}
                        onClick={() => setSelectedCompanyId(company.id)}
                      >
                        <div className="company-radio">
                          <input
                            type="radio"
                            name="company"
                            value={company.id}
                            checked={selectedCompanyId === company.id}
                            onChange={() => setSelectedCompanyId(company.id)}
                          />
                        </div>
                        <div className="company-info">
                          <div className="company-name">{company.name}</div>
                        </div>
                      </div>
                    ))}
                  </div>

                  <button
                    className="login-submit-btn"
                    type="button"
                    onClick={handleCompanySelection}
                    disabled={!selectedCompanyId || loading}
                  >
                    {loading ? "Cargando..." : "Continuar"}
                  </button>

                  <div className="company-selector-back">
                    <button
                      type="button"
                      className="verification-back-btn"
                      onClick={() => {
                        setShowCompanySelector(false);
                        setAvailableCompanies([]);
                        setSelectedCompanyId("");
                        setSavedCredentials(null);
                      }}
                      disabled={loading}
                    >
                      <i className="mdi mdi-arrow-left me-2"></i>
                      Volver al login
                    </button>
                  </div>
                </div>
              ) : showVerification ? (
                <div className="verification-container">
                  <div className="verification-code-inputs">
                    {verificationCode.map((digit, index) => (
                      <input
                        key={index}
                        id={`login-code-${index}`}
                        type="text"
                        inputMode="numeric"
                        maxLength={1}
                        value={digit}
                        onChange={(e) => handleCodeChange(index, e.target.value)}
                        onKeyDown={(e) => handleCodeKeyDown(index, e)}
                        onPaste={handlePaste}
                        className="verification-input"
                        disabled={loading}
                        autoFocus={index === 0}
                      />
                    ))}
                  </div>

                  <div className="verification-actions">
                    <button
                      type="button"
                      className="verification-resend-btn"
                      onClick={handleResendCode}
                      disabled={resendCooldown > 0 || loading}
                    >
                      {resendCooldown > 0
                        ? `Reenviar código (${resendCooldown}s)`
                        : "Reenviar código"}
                    </button>
                  </div>

                  <div className="verification-back">
                    <button
                      type="button"
                      className="verification-back-btn"
                      onClick={() => {
                        setShowVerification(false);
                        setVerificationCode(["", "", "", "", "", ""]);
                        setVerificationEmail("");
                        setSavedCredentials(null);
                      }}
                      disabled={loading}
                    >
                      <i className="mdi mdi-arrow-left me-2"></i>
                      Volver al login
                    </button>
                  </div>
                </div>
              ) : (
                <Form
                  onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                    return false;
                  }}
                >
                  {errorAlert && (
                    <div className="login-error-alert">
                      <i className="mdi mdi-alert-circle me-2"></i>
                      Credenciales incorrectas. Por favor, verifica tus datos.
                    </div>
                  )}

                  <div className="login-form-group">
                    <label className="login-form-label">
                      Correo electrónico
                    </label>
                    <Input
                      name="email"
                      className={`login-form-input ${validation.touched.email && validation.errors.email ? 'is-invalid' : ''}`}
                      placeholder="correo@ejemplo.com"
                      type="email"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.email || ""}
                    />
                    {validation.touched.email && validation.errors.email && (
                      <div className="login-invalid-feedback">
                        {validation.errors.email}
                      </div>
                    )}
                  </div>

                  <div className="login-form-group">
                    <label className="login-form-label">Contraseña</label>
                    <div className="login-password-wrapper">
                      <Input
                        name="password"
                        className={`login-form-input ${validation.touched.password && validation.errors.password ? 'is-invalid' : ''}`}
                        value={validation.values.password || ""}
                        type={passInput}
                        placeholder="Ingresa tu contraseña"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                      />
                      <button
                        type="button"
                        className="login-password-toggle"
                        onClick={() => setPassInput(passInput === "password" ? "text" : "password")}
                      >
                        <i className={passInput === "password" ? "mdi mdi-eye" : "mdi mdi-eye-off"}></i>
                      </button>
                    </div>
                    {validation.touched.password && validation.errors.password && (
                      <div className="login-invalid-feedback">
                        {validation.errors.password}
                      </div>
                    )}
                  </div>

                  <div className="login-forgot-link">
                    <Link to="/password-recovery">
                      <i className="mdi mdi-lock me-1"></i>
                      ¿Olvidaste tu contraseña?
                    </Link>
                  </div>

                  <button
                    className="login-submit-btn"
                    type="submit"
                    disabled={!validation.values.email || !validation.values.password || loading}
                  >
                    {loading ? "Cargando..." : "Iniciar Sesión"}
                  </button>

                  <div className="login-divider">
                    O continúa con
                  </div>

                  <div className="login-social">
                    <LoginSocialFacebook
                      appId={process.env.REACT_APP_FB_APP_ID || '1286925628673362'}
                      fieldsProfile={
                        'id,first_name,last_name,middle_name,name,name_format,picture,short_name,email,gender'
                      }
                      onLoginStart={onLoginStart}
                      onLogoutSuccess={onLogoutSuccess}
                      redirect_uri={"REDIRECT_URI"}
                      onResolve={({ provider, data }) => {
                        setProvider(provider);
                        setProfile(data);
                      }}
                      onReject={err => {
                        console.log(err);
                      }}
                    >
                      <button type="button" className="login-social-btn">
                        <i className="mdi mdi-facebook"></i>
                        Facebook
                      </button>
                    </LoginSocialFacebook>
                  </div>
                </Form>
              )}
            </div>

            <div className="login-footer">
              <p>
                ¿No tienes una cuenta?{" "}
                <Link to="/registro" className="login-footer-link">
                  Regístrate aquí
                </Link>
              </p>
              <p className="login-footer-copyright">
                © {new Date().getFullYear()} InnovaHubGroup{" "}
                <i className="mdi mdi-heart"></i>
              </p>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default withRouter(Login);

Login.propTypes = {
  history: PropTypes.object,
};



{/* 
<script>
  window.fbAsyncInit = function() {
    FB.init({
      appId      : '{your-app-id}',
      cookie     : true,
      xfbml      : true,
      version    : '{api-version}'
    });
      
    FB.AppEvents.logPageView();   
      
  };

  (function(d, s, id){
     var js, fjs = d.getElementsByTagName(s)[0];
     if (d.getElementById(id)) {return;}
     js = d.createElement(s); js.id = id;
     js.src = "https://connect.facebook.net/en_US/sdk.js";
     fjs.parentNode.insertBefore(js, fjs);
   }(document, 'script', 'facebook-jssdk'));
</script>*/}